<template>
  <div class="stats-panel">
    <div class="stats-grid">
      <div class="stat-item total">
        <!-- <div class="item-title">总点数</div> -->
        <div class="stat-row">
          <div class="stat-column">
            <div class="stat-number">{{ stats.total }}</div>
            <div class="stat-label">
            {{ $i18n.t("subscription.home_credits_info_total") }}
          </div>
          </div>
          <div class="stat-column">
            <div class="stat-number">{{ stats.used }}</div>
            <div class="stat-label">
            {{ $i18n.t("subscription.home_credits_info_used") }}
          </div>
          </div>
          <div class="stat-column">
            <div class="stat-number">{{ stats.remaining }}</div>
            <div class="stat-label">
            {{ $i18n.t("subscription.home_credits_info_balance") }}
          </div>
          </div>
        </div>
      </div>
      <!-- <div class="stat-item used">
        <div class="item-title">已使用点数</div>
        <div class="stat-row">
          <div class="stat-column">
            <div class="stat-number">{{ stats.used }}</div>
            <div class="stat-label">AI创作</div>
          </div>
          <div class="stat-column">
            <div class="stat-number">{{ stats.used }}</div>
            <div class="stat-label">AI生图</div>
          </div>
        </div>
      </div>
      <div class="stat-item remaining">
        <div class="item-title">剩余点数</div>
        <div class="stat-row">
          <div class="stat-column">
            <div class="stat-number">{{ stats.remaining }}</div>
            <div class="stat-label">AI创作</div>
          </div>
          <div class="stat-column">
            <div class="stat-number">{{ stats.remaining }}</div>
            <div class="stat-label">AI生图</div>
          </div>
        </div>
      </div> -->
    </div>
  </div>
</template>

<script>
export default {
  name: 'SubscriptionStats',
  props: {
    stats: {
      type: Object,
      required: true,
      default: () => ({
        total: 0,
        used: 0,
        remaining: 0
      })
    }
  }
}
</script>

<style scoped>
.stats-panel {
  background: white;
  padding: 10px 20px;
  border-radius: 0 0 12px 12px;
  box-shadow: 0 4px 20px rgba(0, 0, 0, 0.1);
  margin-bottom: 15px;
}

.stats-grid {
  display: grid;
  grid-template-columns: repeat(auto-fit, minmax(200px, 1fr));
  gap: 10px;
}

.stat-item {
  padding: 10px;
  color: white;
  border-radius: 10px;
}

.item-title {
  display: flex;
  justify-content: center;
  align-items: center;
}

/* 总点数 - 蓝色渐变 */
.stat-item.total {
  background: linear-gradient(45deg, #667eea 0%, #764ba2 100%);
}

/* 已使用点数 - 橙红色渐变 */
.stat-item.used {
  background: linear-gradient(45deg, #f093fb 0%, #f5576c 100%);
}

/* 剩余点数 - 绿色渐变 */
.stat-item.remaining {
  background: linear-gradient(45deg, #4facfe 0%, #00f2fe 100%);
}

.stat-row {
  display: flex;
  justify-content: space-between;
  align-items: center;
  gap: 15px;
}

.stat-column {
  flex: 1;
  text-align: center;
}

.stat-number {
  font-size: 26px;
  font-weight: bold;
  margin-bottom: 5px;
}

.stat-label {
  font-size: 14px;
}

@media (max-width: 268px) {
  .stats-grid {
    grid-template-columns: 1fr;
  }

  .stat-row {
    flex-direction: column;
    gap: 20px;
  }

  .stat-number {
    font-size: 22px;
  }
}
</style>